module.exports = __webpack_public_path__ + "images/emoji/smile.fcf7247755f5fa248687.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smile.png
// module id = 846C
// module chunks = 14